import ComponentManager from "../../componentFramework";
import JsfAjax from "./JsfAjax";

/**
 * JSF forms can be missing their ViewState. This should be fixed in JSF 2.3, but as long as we are on JSF 2.2, we need a fix.
 * This class watches for AJAX events and stores the value of the most recent view state returned. This value is then
 * applied to any new JSF form that is missing the ViewState field or has a ViewState field without a value.
 */
export default class JsfViewStateFix {
	private static instance: JsfViewStateFix;

	private viewState: string | null = null;

	static getInstance(): JsfViewStateFix {
		if (JsfViewStateFix.instance === undefined) {
			JsfViewStateFix.instance = new JsfViewStateFix();
		}
		return JsfViewStateFix.instance;
	}

	private constructor() {
		JsfAjax.getInstance().addEventListener("success", ev => {
			if (ev.responseXML !== undefined && ev.responseXML !== null) {
				this.viewState = JsfViewStateFix.getViewStateFromResponseXML(ev.responseXML);
			}
		});
		JsfAjax.getInstance().addEventListener("always", () => {
			document.querySelectorAll("form").forEach(form => {
				const viewStateElements = form.querySelectorAll(':scope input[name="javax.faces.ViewState"]');
				for (let i = 1; i < viewStateElements.length; i++) {
					const viewStateElement = viewStateElements.item(i);
					(viewStateElement.parentNode ?? viewStateElement.parentElement)?.removeChild(viewStateElement);
				}
			});
		});
	}
	private static getViewStateFromResponseXML(responseXML: Document): string|null {
		const updates = responseXML.getElementsByTagName("update");
		const regex = /^([\w]+:)?javax\.faces\.ViewState(:[0-9]+)?$/;
		for (let i = 0; i < updates.length; i++) {
			const id = updates[i]!.getAttribute("id");
			if (id !== null && id.match(regex)) {
				return updates[i]!.textContent; // textContent = string|null
			}
		}
		return null;
	}

	public applyViewStateToForm(form: HTMLFormElement): boolean {
		if (this.viewState === null || this.viewState === undefined) {
			return false;
			/* TODO (Michael): This can happen that a form is initialized but we don't have a ViewState value. Issue is, this didn't work.. got really strange results.
			const viewStateElems = document.getElementsByName("javax.faces.ViewState");
			if (viewStateElems.length !== 0) {
				const viewState = viewStateElems[0].getAttribute("value");
				if (viewState !== null && viewState.length !== 0) {
					this.viewState = viewState;
				} else {
					return false; // Not successful.
				}
			}
			*/
		}
		
		if (form.method === "post") {
			let viewStateElem = JsfViewStateFix.getViewStateElement(form);

			if (viewStateElem !== null) {
				const elemCurrentValue = viewStateElem.getAttribute("value");
				if (elemCurrentValue === null || elemCurrentValue.length === 0) {
					viewStateElem.setAttribute("value", this.viewState);
				}
			} else {
				viewStateElem = document.createElement("input");
				viewStateElem.setAttribute("name", "javax.faces.ViewState");
				viewStateElem.setAttribute("type", "hidden");
				viewStateElem.setAttribute("autocomplete", "off");
				viewStateElem.setAttribute("value", this.viewState);
				form.appendChild(viewStateElem);
			}
		}

		return true;
	}
	
	private static getViewStateElement(form: HTMLFormElement): Element|null {
		if (form === null) {
			return null;
		}
		if (form.elements.namedItem !== undefined) {
			// Modern browsers have namedItem()
			const viewStateElem = form.elements.namedItem("javax.faces.ViewState");
			if (viewStateElem instanceof Element) {
				return viewStateElem;
			} else if (viewStateElem instanceof RadioNodeList) {
				throw Error(
					`Form with ID "${form.id}" contains multiple elements with a name or id of "javax.faces.ViewState".
					You likely have a form nested inside another form in your templating.`
				);
			}
		}

		// For older browsers
		for (let i = 0; i < form.elements.length; i++) {
			const elem = form.elements[i]!;
			if (elem.getAttribute("name") === "javax.faces.ViewState") {
				return elem;
			}
		}

		return null;
	}
}

@ComponentManager.register()
export class FixFormViewState {
	public static componentTagName = "form";
	constructor(element: HTMLFormElement) {
		JsfViewStateFix.getInstance().applyViewStateToForm(element);
	}
}

// Run once
JsfViewStateFix.getInstance();
